"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypographyStyles = void 0;
require("./typography.css");
const transition = "cds-transition-txjiwsi";
const textAlign = {
  start: "cds-start-s1muvu8a",
  end: "cds-end-erobypy",
  center: "cds-center-c1avs9t3",
  justify: "cds-justify-j1old27y"
};
const display = {
  block: "cds-block-bas7n4z",
  initial: "cds-initial-i1nurjjs",
  inline: "cds-inline-i1b5ormu"
};
const userSelect = {
  none: "cds-none-nhyi79h",
  text: "cds-text-t4kmfzb",
  all: "cds-all-a5opr1h"
};
const overflow = {
  truncate: "cds-truncate-t1dtku18",
  clip: "cds-clip-cme6mjm",
  wrap: "cds-wrap-w1yty5cj",
  break: "cds-break-b8plbaq"
};
const transform = {
  // && to make it more specific than default text-transform
  uppercase: "cds-uppercase-u1cd47hr",
  lowercase: "cds-lowercase-lw5jo8",
  capitalize: "cds-capitalize-c196yqao",
  none: "cds-none-n1y5bxo9"
};
const tabularNumbers = "cds-tabularNumbers-t11sqpt";
const slashedZero = "cds-slashedZero-slvs2p2";
const underline = "cds-underline-u2ps6v4";
const noUnderline = "cds-noUnderline-njp1bsq";
const noWrap = "cds-noWrap-n1er3x1v";
const numberOfLines = "cds-numberOfLines-n6pg8f8";
const getTypographyStyles = props => {
  return [transition, props.align && textAlign[props.align], props.display && display[props.display], props.tabularNumbers && tabularNumbers, props.slashedZero && slashedZero, props.selectable && userSelect[props.selectable], props.underline && underline, props.underline === false && noUnderline,
  // If underline={false} is explicitly set, use underline: none
  props.noWrap && noWrap, props.numberOfLines && numberOfLines, props.overflow && overflow[props.overflow], props.transform && transform[props.transform]];
};
exports.getTypographyStyles = getTypographyStyles;